<div id="homepage-top">
    <div id="quick-quote-container">
        <dcl-quick-quote-placeholder 
            class="dcl-quick-quote-placeholder"
            *ngIf="!filters && !hideQuickQuote"
        >
        </dcl-quick-quote-placeholder>
        <dcl-quick-quote
            class="dcl-quick-quote"
            *ngIf="filters"
            [contextPath]="contextPath"
            [data]="filters"
            useLuxliteTheme="true" 
            (analyticsTrackingEvent)="analyticsTrackingEvent($event)"
            [isDclClRefactorPhase2]="isDclClRefactorPhase2" 
            [isDclAdvancedBooking]="isDclAdvancedBooking"
            [isDclAdvancedBookingPhase2]="isDclAdvancedBookingPhase2"
            [isDclAdvancedBookingPhase3]="isDclAdvancedBookingPhase3 && isNewItinerariesBannerAvailable"
            [isDclShipAdaPhase2]="isDclShipAdaPhase2"
            [isDclInternationalDirectPhase2]="isDclInternationalDirectPhase2"
        >
        </dcl-quick-quote>
    </div>
    <pixie-hero-dcl [id]="id" [title]="title" [ctas]="ctas"></pixie-hero-dcl>
    <div class="stories-rounded-spacer"></div>
</div>

<pixie-stories appDeepLink></pixie-stories>
